export default __webpack_public_path__ + "static/media/ringing.53ede0bd.mp3";